export const STORY_STATUS_PUBLISHED = 'published';
export const STORY_STATUS_DRAFT = 'draft';
